module.exports = __webpack_public_path__ + "static/img/mop-logo.a9027c96.jpg";